import React, { useState } from 'react';
import Order from './Order';
import Receipt from './Receipt';
import KustomReceipt from './Payments/KustomReceipt';
import PaypalReceipt from './Payments/PaypalReceipt';
import ValidatePayment from './ValidatePayment';
import { PaymentCallBackProps } from '../types/PaymentCallBackProps';
import { ReceiptProps } from '../types/ReceiptProps';
import ValidateKustomPayment from './ValidateKustomPayment';

interface ClubSalesProps {
  readonly clubData: any;
  readonly stripeData: any;
  readonly showKustom?: boolean;
  readonly kustomData: any;
}

function ClubSales({ clubData, stripeData, showKustom = false, kustomData }: ClubSalesProps) {
  const { campaign } = clubData;
  return (
    <>
      <div className="image">
        <img
          src={campaign?.image || 'https://www.golfamore.com/assets/img/club-sales/general-banner.jpg'}
          id="campaign-img"
          alt="golfamore"
        />
      </div>
      <Switch clubData={clubData} stripeData={stripeData} showKustom={showKustom} kustomData={kustomData} />
    </>
  );
}

function Switch({ clubData, stripeData, showKustom, kustomData }: ClubSalesProps) {
  const [receiptData, setReceiptData] = useState(null);

  const paymentValidationCallback = (data: PaymentCallBackProps) => {
    setReceiptData(data);
  };

  const validateKustomPayment = showKustom && !!kustomData?.orderId;
  const validatePayment = !!stripeData && stripeData.status === 'success';
  const paymentCanceled = stripeData?.status === 'canceled';

  const showReceipt = !!receiptData;
  const showKustomReceipt = showReceipt && !!receiptData?.kustom?.htmlSnippet;
  const showPaypalReceipt = showReceipt && !!receiptData?.paypal;

  switch (true) {
    case showReceipt && showKustom && showKustomReceipt:
      return <KustomReceipt htmlSnippet={receiptData.kustom.htmlSnippet} />;
    case showReceipt && showKustom && showPaypalReceipt:
      return <PaypalReceipt receipt={receiptData.paypal} golfclub={clubData.name} />;
    case showReceipt && !showPaypalReceipt && !showKustomReceipt:
      return <Receipt clubData={clubData} receiptData={receiptData} />;
    case validatePayment:
      return <ValidatePayment stripeData={stripeData} callback={paymentValidationCallback} />;
    case validateKustomPayment:
      return <ValidateKustomPayment kustomData={kustomData} callback={paymentValidationCallback} />;
    default:
      return (
        <Order
          clubData={clubData}
          callback={(data: ReceiptProps) => setReceiptData(data)}
          paymentCanceled={paymentCanceled}
        />
      );
  }
}

export default ClubSales;
